sw_mwjp_widget.environment = {};

sw_mwjp_widget.environment.mainContainer = document.getElementById("sw-widget-main");

sw_mwjp_widget.environment.url = new URL(window.location.href);
sw_mwjp_widget.environment.brand = sw_mwjp_widget.environment.url.searchParams.get("brand") || 'brand';
sw_mwjp_widget.environment.mainContainer.setAttribute("brand", sw_mwjp_widget.environment.brand);

sw_mwjp_widget.environment.ga_brand = sw_mwjp_widget.environment.url.searchParams.get("ga_brand") || '';
sw_mwjp_widget.environment.mainContainer.setAttribute("ga_brand", sw_mwjp_widget.environment.ga_brand);

sw_mwjp_widget.environment.lang = sw_mwjp_widget.environment.url.searchParams.get("lang") || 'en';
sw_mwjp_widget.environment.mainContainer.setAttribute("lang", sw_mwjp_widget.environment.lang);


sw_mwjp_widget.environment.currency = sw_mwjp_widget.environment.url.searchParams.get("currency") || 'EUR';
sw_mwjp_widget.environment.mainContainer.setAttribute("currency", sw_mwjp_widget.environment.currency);


sw_mwjp_widget.environment.SERVER_DELAY = sw_mwjp_widget.environment.url.searchParams.get("server_update") || 7000;
sw_mwjp_widget.environment.mainContainer.setAttribute("server_update", sw_mwjp_widget.environment.SERVER_DELAY);

sw_mwjp_widget.environment.GAMES_SLIDER_DISPLAY = sw_mwjp_widget.environment.url.searchParams.get("games") || "true";
if (sw_mwjp_widget.environment.GAMES_SLIDER_DISPLAY === "false") {
    document.getElementById("games-container").setAttribute("style", "display: none");
}

sw_mwjp_widget.environment.featureInstanceIds = sw_mwjp_widget.environment.url.searchParams.get("features") || "";
if (sw_mwjp_widget.environment.featureInstanceIds) {
    sw_mwjp_widget.environment.mainContainer.setAttribute("features", sw_mwjp_widget.environment.featureInstanceIds);
}

sw_mwjp_widget.environment.advertising = sw_mwjp_widget.environment.url.searchParams.get("ad") || "false";
if (sw_mwjp_widget.environment.advertising === "false") {
    sw_mwjp_widget.environment.advertising = false;
} else {
    sw_mwjp_widget.environment.advertising = true
}


// send features
gtag('config', 'UA-144301676-1', {
    'custom_map': {'dimension1': 'Feature', 'dimension2': 'Brand'}
});
gtag('event', 'brand_info', {'Feature': sw_mwjp_widget.environment.featureInstanceIds, 'Brand': sw_mwjp_widget.environment.ga_brand});